import React from "react"
import ManagedSolutionsAccountsTable from "./ManagedSolutionsAccountsTable"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findManagedSolutionsAccounts} from "../../resources/managedSolutions"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableCard, DataTableActionHeader, TablePending} from "../DataTable/DataTable"
import {AllowedManagedSolutionsAccountsColumns} from "./ManagedSolutionsAccounts.types"

interface ManagedSolutionsAccountsProps {
	customerId: string
	enableTitle?: boolean
	fullHeight?: boolean
	limit?: number
	title?: string
	includedColumns: Array<AllowedManagedSolutionsAccountsColumns>
}

export default function ManagedSolutionsAccounts({
	customerId,
	enableTitle = true,
	fullHeight = false,
	limit = 10,
	title = "Accounts",
	includedColumns,
}: ManagedSolutionsAccountsProps) {
	const accessToken = useAccessToken()

	const [result, hasPrev, hasNext, prev, next, hasResults] = usePaging(
		limit,
		(offset, limit) => findManagedSolutionsAccounts(accessToken, offset, limit, customerId),
		(x) => x.data.length,
		[customerId],
		`rtl-acc-${customerId}`,
		true
	)

	return (
		<DataTableCard className={"managed-solutions-accounts-card"}>
			<DataTableActionHeader enableSticky={fullHeight} title={enableTitle ? title : null} />
			<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={6} />}>
				{({value: accounts}) => {
					return (
						<ManagedSolutionsAccountsTable
							accounts={accounts.data}
							hasResults={hasResults}
							hasPrev={hasPrev}
							hasNext={hasNext}
							prev={prev}
							next={next}
							isUsingPaging={true}
							fullHeight={fullHeight}
							meta={accounts.meta}
							includedColumns={includedColumns}
						/>
					)
				}}
			</AsyncResultComponent>
		</DataTableCard>
	)
}
